import { render, staticRenderFns } from "./SwissTournament.vue?vue&type=template&id=439f7b93&scoped=true"
import script from "./SwissTournament.vue?vue&type=script&lang=js"
export * from "./SwissTournament.vue?vue&type=script&lang=js"
import style0 from "./SwissTournament.vue?vue&type=style&index=0&id=439f7b93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439f7b93",
  null
  
)

export default component.exports